import { useMemo } from 'react';
import { StyledQrCode } from '../../../security/qr/StyledQrCode';
import { simulationApi } from '../services/simulationApi';

type Props = {
  actorId: string;
  actorNome: string;
  sessionId: string;
  roleLabel?: string;
  onClose: () => void;
};

/**
 * QR de pareamento PWA — mesmo ator da janela, sem JWT na URL.
 */
export function SimActorPairingQrModal({
  actorId,
  actorNome,
  sessionId,
  roleLabel,
  onClose,
}: Props) {
  const qrUrl = useMemo(
    () =>
      simulationApi.buildDevicePairRedirectUrl({
        actorId,
        sessionId,
        origin: window.location.origin,
        promptNotification: true,
      }),
    [actorId, sessionId],
  );

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(qrUrl);
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="border rounded-2xl p-6 max-w-sm w-full text-center shadow-2xl relative bg-[#1e1e2e] border-white/10">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-[#a6adc8] hover:text-white transition-all text-sm font-bold bg-transparent border-none cursor-pointer"
          aria-label="Fechar"
        >
          ✕
        </button>
        <div className="text-sm font-bold mb-1 text-white">Pareamento PWA</div>
        {roleLabel && (
          <div className="text-[10px] uppercase tracking-wide text-[#6c7086] mb-1">{roleLabel}</div>
        )}
        <div className="text-xs font-mono mb-1 text-[#89b4fa]">{actorNome}</div>
        <div className="text-[10px] text-[#6c7086] mb-4 font-mono">
          sessão {sessionId.slice(0, 8)}… · TTL 15 min
        </div>

        <div className="bg-white p-3 rounded-xl inline-block mb-4 shadow-inner">
          <StyledQrCode value={qrUrl} size={200} />
        </div>

        <p className="text-xs leading-normal px-2 mb-4 text-[#a6adc8]">
          Escaneie com o celular de teste para entrar como este ator na mesma sessão de
          simulação e ativar notificações push.
        </p>

        <button
          type="button"
          onClick={() => {
            void copyLink();
            onClose();
          }}
          className="text-xs font-bold w-full py-2.5 rounded-xl transition-all border bg-white/5 hover:bg-white/10 text-white border-white/10"
        >
          Copiar link de acesso
        </button>
      </div>
    </div>
  );
}
